function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var AccessibleMenu = function () {
  "use strict";

  var Y = Object.defineProperty;
  var ee = function ee(_, y, M) {
    return y in _ ? Y(_, y, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: M
    }) : _[y] = M;
  };
  var u = function u(_, y, M) {
    return ee(_, _typeof(y) != "symbol" ? y + "" : y, M);
  };
  function _(r, e) {
    var _e$classList;
    r === "" || r.length === 0 || (typeof r == "string" ? e.classList.add(r) : (_e$classList = e.classList).add.apply(_e$classList, _toConsumableArray(r)));
  }
  function y(r, e) {
    var _e$classList2;
    r === "" || r.length === 0 || (typeof r == "string" ? e.classList.remove(r) : (_e$classList2 = e.classList).remove.apply(_e$classList2, _toConsumableArray(r)));
  }
  function M(r, e) {
    try {
      if (_typeof(e) != "object") {
        var t = _typeof(e);
        throw new TypeError("Elements given to isValidInstance() must be inside of an object. \"".concat(t, "\" given."));
      }
      for (var _t in e) if (!(e[_t] instanceof r)) {
        var s = _typeof(e[_t]);
        throw new TypeError("".concat(_t, " must be an instance of ").concat(r.name, ". \"").concat(s, "\" given."));
      }
      return {
        status: !0,
        error: null
      };
    } catch (t) {
      return {
        status: !1,
        error: t
      };
    }
  }
  function c(r, e) {
    try {
      if (_typeof(e) != "object") {
        var t = _typeof(e);
        throw new TypeError("Values given to isValidType() must be inside of an object. \"".concat(t, "\" given."));
      }
      for (var _t2 in e) {
        var s = _typeof(e[_t2]);
        if (s !== r) throw new TypeError("".concat(_t2, " must be a ").concat(r, ". \"").concat(s, "\" given."));
      }
      return {
        status: !0,
        error: null
      };
    } catch (t) {
      return {
        status: !1,
        error: t
      };
    }
  }
  function x(r) {
    try {
      if (_typeof(r) != "object") {
        var e = _typeof(r);
        throw new TypeError("Values given to isQuerySelector() must be inside of an object. \"".concat(e, "\" given."));
      }
      for (var _e in r) try {
        if (r[_e] === null) throw new Error();
        document.querySelector(r[_e]);
      } catch (_unused) {
        throw new TypeError("".concat(_e, " must be a valid query selector. \"").concat(r[_e], "\" given."));
      }
      return {
        status: !0,
        error: null
      };
    } catch (e) {
      return {
        status: !1,
        error: e
      };
    }
  }
  function A(r) {
    try {
      if (_typeof(r) != "object" || Array.isArray(r)) {
        var e = _typeof(r);
        throw new TypeError("Values given to isValidClassList() must be inside of an object. \"".concat(e, "\" given."));
      }
      var _loop = function _loop(_e2) {
        var t = _typeof(r[_e2]);
        if (t !== "string") {
          if (Array.isArray(r[_e2])) r[_e2].forEach(function (s) {
            if (typeof s != "string") throw new TypeError("".concat(_e2, " must be a string or an array of strings. An array containing non-strings given."));
          });else throw new TypeError("".concat(_e2, " must be a string or an array of strings. \"").concat(t, "\" given."));
        } else {
          var s = {};
          s[_e2] = r[_e2], x(s);
        }
      };
      for (var _e2 in r) {
        _loop(_e2);
      }
      return {
        status: !0,
        error: null
      };
    } catch (e) {
      return {
        status: !1,
        error: e
      };
    }
  }
  function V(r) {
    try {
      if (_typeof(r) != "object") {
        var t = _typeof(r);
        throw new TypeError("Values given to isValidState() must be inside of an object. \"".concat(t, "\" given."));
      }
      var e = ["none", "self", "child"];
      for (var _t3 in r) if (!e.includes(r[_t3])) throw new TypeError("".concat(_t3, " must be one of the following values: ").concat(e.join(", "), ". \"").concat(r[_t3], "\" given."));
      return {
        status: !0,
        error: null
      };
    } catch (e) {
      return {
        status: !1,
        error: e
      };
    }
  }
  function P(r) {
    try {
      if (_typeof(r) != "object") {
        var t = _typeof(r);
        throw new TypeError("Values given to isValidEvent() must be inside of an object. \"".concat(t, "\" given."));
      }
      var e = ["none", "mouse", "keyboard", "character"];
      for (var _t4 in r) if (!e.includes(r[_t4])) throw new TypeError("".concat(_t4, " must be one of the following values: ").concat(e.join(", "), ". \"").concat(r[_t4], "\" given."));
      return {
        status: !0,
        error: null
      };
    } catch (e) {
      return {
        status: !1,
        error: e
      };
    }
  }
  function N(r) {
    try {
      if (_typeof(r) != "object") {
        var t = _typeof(r);
        throw new TypeError("Values given to isValidHoverType() must be inside of an object. \"".concat(t, "\" given."));
      }
      var e = ["off", "on", "dynamic"];
      for (var _t5 in r) if (!e.includes(r[_t5])) throw new TypeError("".concat(_t5, " must be one of the following values: ").concat(e.join(", "), ". \"").concat(r[_t5], "\" given."));
      return {
        status: !0,
        error: null
      };
    } catch (e) {
      return {
        status: !1,
        error: e
      };
    }
  }
  function K(r, e) {
    if (c("string", {
      tagName: r
    }).status && M(HTMLElement, e).status) {
      var t = r.toLowerCase();
      var s = !0;
      for (var n in e) e[n].tagName.toLowerCase() !== t && (s = !1);
      return s;
    } else return !1;
  }
  var L = /*#__PURE__*/function () {
    function L(_ref) {
      var e = _ref.menuToggleElement,
        t = _ref.parentElement,
        s = _ref.controlledMenu,
        _ref$parentMenu = _ref.parentMenu,
        n = _ref$parentMenu === void 0 ? null : _ref$parentMenu;
      _classCallCheck(this, L);
      u(this, "_dom", {
        toggle: null,
        parent: null
      });
      u(this, "_elements", {
        controlledMenu: null,
        parentMenu: null
      });
      u(this, "_open", !1);
      u(this, "_expandEvent", new CustomEvent("accessibleMenuExpand", {
        bubbles: !0,
        detail: {
          toggle: this
        }
      }));
      u(this, "_collapseEvent", new CustomEvent("accessibleMenuCollapse", {
        bubbles: !0,
        detail: {
          toggle: this
        }
      }));
      this._dom.toggle = e, this._dom.parent = t, this._elements.controlledMenu = s, this._elements.parentMenu = n;
    }
    return _createClass(L, [{
      key: "initialize",
      value: function initialize() {
        this._setIds(), this._setAriaAttributes(), this._collapse(!1);
      }
    }, {
      key: "dom",
      get: function get() {
        return this._dom;
      }
    }, {
      key: "elements",
      get: function get() {
        return this._elements;
      }
    }, {
      key: "isOpen",
      get: function get() {
        return this._open;
      },
      set: function set(e) {
        c("boolean", {
          value: e
        }), this._open = e;
      }
    }, {
      key: "_setIds",
      value: function _setIds() {
        var e;
        if (this.dom.toggle.id === "" || this.elements.controlledMenu.dom.menu.id === "") {
          var t = Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 10);
          var s = ((e = this.dom.toggle.innerText) == null ? void 0 : e.replace(/[^a-zA-Z0-9\s]/g, "")) || "",
            n = t;
          !s.replace(/\s/g, "").length && this.dom.toggle.getAttribute("aria-label") && (s = this.dom.toggle.getAttribute("aria-label").replace(/[^a-zA-Z0-9\s]/g, "")), s.replace(/\s/g, "").length > 0 && (s = s.toLowerCase().replace(/\s+/g, "-"), s.startsWith("-") && (s = s.substring(1)), s.endsWith("-") && (s = s.slice(0, -1)), n = "".concat(s, "-").concat(n)), this.dom.toggle.id = this.dom.toggle.id || "menu-button-".concat(n), this.elements.controlledMenu.dom.menu.id = this.elements.controlledMenu.dom.menu.id || "menu-".concat(n);
        }
      }
    }, {
      key: "_setAriaAttributes",
      value: function _setAriaAttributes() {
        this.dom.toggle.setAttribute("aria-expanded", "false"), this.elements.controlledMenu.dom.menu.setAttribute("aria-labelledby", this.dom.toggle.id);
      }
    }, {
      key: "_expand",
      value: function _expand() {
        var _this = this;
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        var _this$elements$contro = this.elements.controlledMenu,
          t = _this$elements$contro.closeClass,
          s = _this$elements$contro.openClass,
          n = _this$elements$contro.transitionClass,
          i = _this$elements$contro.openDuration;
        this.dom.toggle.setAttribute("aria-expanded", "true"), this.elements.controlledMenu.elements.rootMenu.hasOpened = !0, n !== "" ? (_(n, this.elements.controlledMenu.dom.menu), requestAnimationFrame(function () {
          y(t, _this.elements.controlledMenu.dom.menu), requestAnimationFrame(function () {
            _(s, _this.elements.controlledMenu.dom.menu), requestAnimationFrame(function () {
              setTimeout(function () {
                y(n, _this.elements.controlledMenu.dom.menu);
              }, i);
            });
          });
        })) : (_(s, this.elements.controlledMenu.dom.menu), y(t, this.elements.controlledMenu.dom.menu)), e && this.dom.toggle.dispatchEvent(this._expandEvent);
      }
    }, {
      key: "_collapse",
      value: function _collapse() {
        var _this2 = this;
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
        var _this$elements$contro2 = this.elements.controlledMenu,
          t = _this$elements$contro2.closeClass,
          s = _this$elements$contro2.openClass,
          n = _this$elements$contro2.transitionClass,
          i = _this$elements$contro2.closeDuration;
        this.dom.toggle.setAttribute("aria-expanded", "false"), n !== "" ? (_(n, this.elements.controlledMenu.dom.menu), requestAnimationFrame(function () {
          y(s, _this2.elements.controlledMenu.dom.menu), requestAnimationFrame(function () {
            _(t, _this2.elements.controlledMenu.dom.menu), requestAnimationFrame(function () {
              setTimeout(function () {
                y(n, _this2.elements.controlledMenu.dom.menu);
              }, i);
            });
          });
        })) : (_(t, this.elements.controlledMenu.dom.menu), y(s, this.elements.controlledMenu.dom.menu)), e && this.dom.toggle.dispatchEvent(this._collapseEvent);
      }
    }, {
      key: "open",
      value: function open() {
        this.elements.controlledMenu.focusState = "self", this.isOpen || (this._expand(), this.isOpen = !0);
      }
    }, {
      key: "preview",
      value: function preview() {
        this.elements.parentMenu && (this.elements.parentMenu.focusState = "self"), this.isOpen || (this._expand(), this.isOpen = !0);
      }
    }, {
      key: "close",
      value: function close() {
        this.isOpen && (this.elements.controlledMenu.blur(), this.elements.parentMenu && (this.elements.parentMenu.focusState = "self"), this._collapse(), this.isOpen = !1);
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.isOpen ? this.close() : this.open();
      }
    }, {
      key: "closeSiblings",
      value: function closeSiblings() {
        var _this3 = this;
        this.elements.parentMenu && this.elements.parentMenu.elements.submenuToggles.forEach(function (e) {
          e !== _this3 && e.close();
        });
      }
    }, {
      key: "closeChildren",
      value: function closeChildren() {
        this.elements.controlledMenu.elements.submenuToggles.forEach(function (e) {
          return e.close();
        });
      }
    }]);
  }();
  var O = /*#__PURE__*/function () {
    function O(_ref2) {
      var e = _ref2.menuItemElement,
        t = _ref2.menuLinkElement,
        s = _ref2.parentMenu,
        _ref2$isSubmenuItem = _ref2.isSubmenuItem,
        n = _ref2$isSubmenuItem === void 0 ? !1 : _ref2$isSubmenuItem,
        _ref2$childMenu = _ref2.childMenu,
        i = _ref2$childMenu === void 0 ? null : _ref2$childMenu,
        _ref2$toggle = _ref2.toggle,
        l = _ref2$toggle === void 0 ? null : _ref2$toggle;
      _classCallCheck(this, O);
      u(this, "_dom", {
        item: null,
        link: null
      });
      u(this, "_elements", {
        parentMenu: null,
        childMenu: null,
        toggle: null
      });
      u(this, "_submenu", !1);
      this._dom.item = e, this._dom.link = t, this._elements.parentMenu = s, this._elements.childMenu = i, this._elements.toggle = l, this._submenu = n;
    }
    return _createClass(O, [{
      key: "initialize",
      value: function initialize() {}
    }, {
      key: "dom",
      get: function get() {
        return this._dom;
      }
    }, {
      key: "elements",
      get: function get() {
        return this._elements;
      }
    }, {
      key: "isSubmenuItem",
      get: function get() {
        return this._submenu;
      }
    }, {
      key: "focus",
      value: function focus() {
        var _this4 = this;
        this.elements.parentMenu.shouldFocus && requestAnimationFrame(function () {
          _this4.dom.link.focus();
        });
      }
    }, {
      key: "blur",
      value: function blur() {
        var _this5 = this;
        this.elements.parentMenu.shouldFocus && requestAnimationFrame(function () {
          _this5.dom.link.blur();
        });
      }
    }]);
  }();
  function b(r) {
    try {
      var e = r.key || r.keyCode,
        t = {
          Enter: e === "Enter" || e === 13,
          Space: e === " " || e === "Spacebar" || e === 32,
          Escape: e === "Escape" || e === "Esc" || e === 27,
          ArrowUp: e === "ArrowUp" || e === "Up" || e === 38,
          ArrowRight: e === "ArrowRight" || e === "Right" || e === 39,
          ArrowDown: e === "ArrowDown" || e === "Down" || e === 40,
          ArrowLeft: e === "ArrowLeft" || e === "Left" || e === 37,
          Home: e === "Home" || e === 36,
          End: e === "End" || e === 35,
          Character: isNaN(e) && !!e.match(/^[a-zA-Z]{1}$/),
          Tab: e === "Tab" || e === 9,
          Asterisk: e === "*" || e === 56
        };
      return Object.keys(t).find(function (s) {
        return t[s] === !0;
      }) || "";
    } catch (_unused2) {
      return "";
    }
  }
  function o(r) {
    r.preventDefault(), r.stopPropagation();
  }
  var k = /*#__PURE__*/function () {
    function k(_ref3) {
      var e = _ref3.menuElement,
        _ref3$menuItemSelecto = _ref3.menuItemSelector,
        t = _ref3$menuItemSelecto === void 0 ? "li" : _ref3$menuItemSelecto,
        _ref3$menuLinkSelecto = _ref3.menuLinkSelector,
        s = _ref3$menuLinkSelecto === void 0 ? "a" : _ref3$menuLinkSelecto,
        _ref3$submenuItemSele = _ref3.submenuItemSelector,
        n = _ref3$submenuItemSele === void 0 ? "li:has(ul)" : _ref3$submenuItemSele,
        _ref3$submenuToggleSe = _ref3.submenuToggleSelector,
        i = _ref3$submenuToggleSe === void 0 ? "a" : _ref3$submenuToggleSe,
        _ref3$submenuSelector = _ref3.submenuSelector,
        l = _ref3$submenuSelector === void 0 ? "ul" : _ref3$submenuSelector,
        _ref3$controllerEleme = _ref3.controllerElement,
        h = _ref3$controllerEleme === void 0 ? null : _ref3$controllerEleme,
        _ref3$containerElemen = _ref3.containerElement,
        m = _ref3$containerElemen === void 0 ? null : _ref3$containerElemen,
        _ref3$openClass = _ref3.openClass,
        a = _ref3$openClass === void 0 ? "show" : _ref3$openClass,
        _ref3$closeClass = _ref3.closeClass,
        p = _ref3$closeClass === void 0 ? "hide" : _ref3$closeClass,
        _ref3$transitionClass = _ref3.transitionClass,
        f = _ref3$transitionClass === void 0 ? "transitioning" : _ref3$transitionClass,
        _ref3$transitionDurat = _ref3.transitionDuration,
        g = _ref3$transitionDurat === void 0 ? 250 : _ref3$transitionDurat,
        _ref3$openDuration = _ref3.openDuration,
        d = _ref3$openDuration === void 0 ? -1 : _ref3$openDuration,
        _ref3$closeDuration = _ref3.closeDuration,
        T = _ref3$closeDuration === void 0 ? -1 : _ref3$closeDuration,
        _ref3$isTopLevel = _ref3.isTopLevel,
        C = _ref3$isTopLevel === void 0 ? !0 : _ref3$isTopLevel,
        _ref3$parentMenu = _ref3.parentMenu,
        E = _ref3$parentMenu === void 0 ? null : _ref3$parentMenu,
        _ref3$hoverType = _ref3.hoverType,
        v = _ref3$hoverType === void 0 ? "off" : _ref3$hoverType,
        _ref3$hoverDelay = _ref3.hoverDelay,
        I = _ref3$hoverDelay === void 0 ? 250 : _ref3$hoverDelay,
        _ref3$enterDelay = _ref3.enterDelay,
        w = _ref3$enterDelay === void 0 ? -1 : _ref3$enterDelay,
        _ref3$leaveDelay = _ref3.leaveDelay,
        S = _ref3$leaveDelay === void 0 ? -1 : _ref3$leaveDelay,
        _ref3$prefix = _ref3.prefix,
        D = _ref3$prefix === void 0 ? "am-" : _ref3$prefix;
      _classCallCheck(this, k);
      u(this, "_MenuType", k);
      u(this, "_MenuItemType", O);
      u(this, "_MenuToggleType", L);
      u(this, "_dom", {
        menu: null,
        menuItems: [],
        submenuItems: [],
        submenuToggles: [],
        submenus: [],
        controller: null,
        container: null
      });
      u(this, "_selectors", {
        menuItems: "",
        menuLinks: "",
        submenuItems: "",
        submenuToggles: "",
        submenus: ""
      });
      u(this, "_elements", {
        menuItems: [],
        submenuToggles: [],
        controller: null,
        parentMenu: null,
        rootMenu: null
      });
      u(this, "_openClass", "show");
      u(this, "_closeClass", "hide");
      u(this, "_transitionClass", "transitioning");
      u(this, "_transitionDuration", 250);
      u(this, "_openDuration", -1);
      u(this, "_closeDuration", -1);
      u(this, "_root", !0);
      u(this, "_currentChild", 0);
      u(this, "_focusState", "none");
      u(this, "_currentEvent", "none");
      u(this, "_hoverType", "off");
      u(this, "_hoverDelay", 250);
      u(this, "_enterDelay", -1);
      u(this, "_leaveDelay", -1);
      u(this, "_prefix", "am-");
      u(this, "_hoverTimeout", null);
      u(this, "_hasOpened", !1);
      u(this, "_errors", []);
      this._dom.menu = e, this._dom.controller = h, this._dom.container = m, this._selectors.menuItems = t, this._selectors.menuLinks = s, this._selectors.submenuItems = n, this._selectors.submenuToggles = i, this._selectors.submenus = l, this._elements.menuItems = [], this._elements.submenuToggles = [], this._elements.controller = null, this._elements.parentMenu = E, this._elements.rootMenu = C ? this : null, this._openClass = a || "", this._closeClass = p || "", this._transitionClass = f || "", this._transitionDuration = g, this._openDuration = d, this._closeDuration = T, this._prefix = D || "", this._root = C, this._hoverType = v, this._hoverDelay = I, this._enterDelay = w, this._leaveDelay = S;
    }
    return _createClass(k, [{
      key: "initialize",
      value: function initialize() {
        if (!this._validate()) throw new Error("AccessibleMenu: cannot initialize menu. The following errors have been found:\n - ".concat(this.errors.join("\n - ")));
        if (this.elements.rootMenu === null && this._findRootMenu(this), this._setDOMElements(), this.isTopLevel && this.dom.controller && this.dom.container) {
          var e = new this._MenuToggleType({
            menuToggleElement: this.dom.controller,
            parentElement: this.dom.container,
            controlledMenu: this
          });
          K("button", {
            toggle: e.dom.toggle
          }) || e.dom.toggle.setAttribute("role", "button"), e.dom.toggle.setAttribute("aria-controls", this.dom.menu.id), this._elements.controller = e;
        }
        this._createChildElements(), this._setTransitionDurations(), this.isTopLevel && (window.AccessibleMenu = window.AccessibleMenu || {
          menus: {}
        }, window.AccessibleMenu.menus[this.dom.menu.id] = this);
      }
    }, {
      key: "dom",
      get: function get() {
        return this._dom;
      }
    }, {
      key: "selectors",
      get: function get() {
        return this._selectors;
      }
    }, {
      key: "elements",
      get: function get() {
        return this._elements;
      }
    }, {
      key: "isTopLevel",
      get: function get() {
        return this._root;
      }
    }, {
      key: "openClass",
      get: function get() {
        return this.isTopLevel ? this._openClass : this.elements.rootMenu.openClass;
      },
      set: function set(e) {
        A({
          openClass: e
        }), this._openClass !== e && (this._openClass = e);
      }
    }, {
      key: "closeClass",
      get: function get() {
        return this.isTopLevel ? this._closeClass : this.elements.rootMenu.closeClass;
      },
      set: function set(e) {
        A({
          closeClass: e
        }), this._closeClass !== e && (this._closeClass = e);
      }
    }, {
      key: "transitionClass",
      get: function get() {
        return this.isTopLevel ? this._transitionClass : this.elements.rootMenu.transitionClass;
      },
      set: function set(e) {
        A({
          transitionClass: e
        }), this._transitionClass !== e && (this._transitionClass = e);
      }
    }, {
      key: "transitionDuration",
      get: function get() {
        return this.isTopLevel ? this._transitionDuration : this.elements.rootMenu.transitionDuration;
      },
      set: function set(e) {
        c("number", {
          value: e
        }), this._transitionDuration !== e && (this._transitionDuration = e, this._setTransitionDurations());
      }
    }, {
      key: "openDuration",
      get: function get() {
        return this._openDuration === -1 ? this.transitionDuration : this.isTopLevel ? this._openDuration : this.elements.rootMenu.openDuration;
      },
      set: function set(e) {
        c("number", {
          value: e
        }), this._openDuration !== e && (this._openDuration = e, this._setTransitionDurations());
      }
    }, {
      key: "closeDuration",
      get: function get() {
        return this._closeDuration === -1 ? this.transitionDuration : this.isTopLevel ? this._closeDuration : this.elements.rootMenu.closeDuration;
      },
      set: function set(e) {
        c("number", {
          value: e
        }), this._closeDuration !== e && (this._closeDuration = e, this._setTransitionDurations());
      }
    }, {
      key: "currentChild",
      get: function get() {
        return this._currentChild;
      },
      set: function set(e) {
        c("number", {
          value: e
        });
        function t(s) {
          if (["mouse", "character"].includes(s.currentEvent) && s.elements.parentMenu) {
            var i = 0,
              l = !1;
            for (; !l && i < s.elements.parentMenu.elements.menuItems.length;) {
              var h = s.elements.parentMenu.elements.menuItems[i];
              h.isSubmenuItem && h.elements.toggle.elements.controlledMenu === s && (l = !0, s.elements.parentMenu.currentEvent = s.currentEvent, s.elements.parentMenu.currentChild = i), i++;
            }
          }
        }
        e < -1 ? (this._currentChild = -1, t(this)) : e >= this.elements.menuItems.length ? (this._currentChild = this.elements.menuItems.length - 1, t(this)) : this.focusChild !== e && (this._currentChild = e, t(this));
      }
    }, {
      key: "focusState",
      get: function get() {
        return this._focusState;
      },
      set: function set(e) {
        V({
          value: e
        }), this._focusState !== e && (this._focusState = e), this.elements.submenuToggles.length > 0 && (e === "self" || e === "none") && this.elements.submenuToggles.forEach(function (t) {
          t.elements.controlledMenu.focusState = "none";
        }), this.elements.parentMenu && (e === "self" || e === "child") && (this.elements.parentMenu.focusState = "child");
      }
    }, {
      key: "currentEvent",
      get: function get() {
        return this._currentEvent;
      },
      set: function set(e) {
        P({
          value: e
        }), this._currentEvent !== e && (this._currentEvent = e, this.elements.submenuToggles.length > 0 && this.elements.submenuToggles.forEach(function (t) {
          t.elements.controlledMenu.currentEvent = e;
        }));
      }
    }, {
      key: "currentMenuItem",
      get: function get() {
        return this.elements.menuItems[this.currentChild];
      }
    }, {
      key: "hoverType",
      get: function get() {
        return this._root ? this._hoverType : this.elements.rootMenu.hoverType;
      },
      set: function set(e) {
        N({
          value: e
        }), this._hoverType !== e && (this._hoverType = e);
      }
    }, {
      key: "hoverDelay",
      get: function get() {
        return this._root ? this._hoverDelay : this.elements.rootMenu.hoverDelay;
      },
      set: function set(e) {
        c("number", {
          value: e
        }), this._hoverDelay !== e && (this._hoverDelay = e);
      }
    }, {
      key: "enterDelay",
      get: function get() {
        return this._enterDelay === -1 ? this.hoverDelay : this._root ? this._enterDelay : this.elements.rootMenu.enterDelay;
      },
      set: function set(e) {
        c("number", {
          value: e
        }), this._enterDelay !== e && (this._enterDelay = e);
      }
    }, {
      key: "leaveDelay",
      get: function get() {
        return this._leaveDelay === -1 ? this.hoverDelay : this._root ? this._leaveDelay : this.elements.rootMenu.leaveDelay;
      },
      set: function set(e) {
        c("number", {
          value: e
        }), this._leaveDelay !== e && (this._leaveDelay = e);
      }
    }, {
      key: "prefix",
      get: function get() {
        return this._root ? this._prefix : this.elements.rootMenu.prefix;
      },
      set: function set(e) {
        c("string", {
          value: e
        }), this._prefix !== e && (this._prefix = e);
      }
    }, {
      key: "shouldFocus",
      get: function get() {
        var e = !1;
        return (this.currentEvent === "keyboard" || this.currentEvent === "character") && (e = !0), this.currentEvent === "mouse" && this.hoverType === "dynamic" && (e = !0), e;
      }
    }, {
      key: "hasOpened",
      get: function get() {
        return this._root ? this._hasOpened : this.elements.rootMenu.hasOpened;
      },
      set: function set(e) {
        c("boolean", {
          value: e
        }), this._hasOpened !== e && (this._hasOpened = e);
      }
    }, {
      key: "errors",
      get: function get() {
        return this._errors;
      }
    }, {
      key: "_validate",
      value: function _validate() {
        var e = !0,
          t;
        this._dom.container !== null || this._dom.controller !== null ? t = M(HTMLElement, {
          menuElement: this._dom.menu,
          controllerElement: this._dom.controller,
          containerElement: this._dom.container
        }) : t = M(HTMLElement, {
          menuElement: this._dom.menu
        }), t.status || (this._errors.push(t.error.message), e = !1);
        var s;
        if (this._selectors.submenuItems !== "" ? s = x({
          menuItemSelector: this._selectors.menuItems,
          menuLinkSelector: this._selectors.menuLinks,
          submenuItemSelector: this._selectors.submenuItems,
          submenuToggleSelector: this._selectors.submenuToggles,
          submenuSelector: this._selectors.submenus
        }) : s = x({
          menuItemSelector: this._selectors.menuItems,
          menuLinkSelector: this._selectors.menuLinks
        }), s.status || (this._errors.push(s.error.message), e = !1), this._openClass !== "") {
          var d = A({
            openClass: this._openClass
          });
          d.status || (this._errors.push(d.error.message), e = !1);
        }
        if (this._closeClass !== "") {
          var _d = A({
            closeClass: this._closeClass
          });
          _d.status || (this._errors.push(_d.error.message), e = !1);
        }
        if (this._transitionClass !== "") {
          var _d2 = A({
            transitionClass: this._transitionClass
          });
          _d2.status || (this._errors.push(_d2.error.message), e = !1);
        }
        var n = c("number", {
          transitionDuration: this._transitionDuration
        });
        n.status || (this._errors.push(n.error.message), e = !1);
        var i = c("number", {
          openDuration: this._openDuration
        });
        i.status || (this._errors.push(i.error.message), e = !1);
        var l = c("number", {
          closeDuration: this._closeDuration
        });
        l.status || (this._errors.push(l.error.message), e = !1);
        var h = c("boolean", {
          isTopLevel: this._root
        });
        if (h.status || (this._errors.push(h.error.message), e = !1), this._elements.parentMenu !== null) {
          var _d3 = M(k, {
            parentMenu: this._elements.parentMenu
          });
          _d3.status || (this._errors.push(_d3.error.message), e = !1);
        }
        var m = N({
          hoverType: this._hoverType
        });
        m.status || (this._errors.push(m.error.message), e = !1);
        var a = c("number", {
          hoverDelay: this._hoverDelay
        });
        a.status || (this._errors.push(a.error.message), e = !1);
        var p = c("number", {
          enterDelay: this._enterDelay
        });
        p.status || (this._errors.push(p.error.message), e = !1);
        var f = c("number", {
          leaveDelay: this._leaveDelay
        });
        f.status || (this._errors.push(f.error.message), e = !1);
        var g = c("string", {
          prefix: this._prefix
        });
        return g.status || (this._errors.push(g.error.message), e = !1), e;
      }
    }, {
      key: "_setDOMElementType",
      value: function _setDOMElementType(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dom.menu;
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
        if (typeof this.selectors[e] == "string") {
          if (!Array.isArray(this.dom[e])) throw new Error("AccessibleMenu: The \"".concat(e, "\" element cannot be set through _setDOMElementType."));
          t !== this.dom.menu && M(HTMLElement, {
            base: t
          });
          var i = Array.from(t.querySelectorAll(this.selectors[e])).filter(function (l) {
            return l.parentElement === t;
          });
          s ? this._dom[e] = i : this._dom[e] = [].concat(_toConsumableArray(this._dom[e]), _toConsumableArray(i));
        } else throw new Error("AccessibleMenu: \"".concat(e, "\" is not a valid element type within the menu."));
      }
    }, {
      key: "_resetDOMElementType",
      value: function _resetDOMElementType(e) {
        if (_typeof(this.dom[e]) < "u") {
          if (!Array.isArray(this.dom[e])) throw new Error("AccessibleMenu: The \"".concat(e, "\" element cannot be reset through _resetDOMElementType."));
          this._dom[e] = [];
        } else throw new Error("AccessibleMenu: \"".concat(e, "\" is not a valid element type within the menu."));
      }
    }, {
      key: "_setDOMElements",
      value: function _setDOMElements() {
        var _this6 = this;
        this._setDOMElementType("menuItems"), this.selectors.submenuItems !== "" && (this._setDOMElementType("submenuItems"), this._resetDOMElementType("submenuToggles"), this._resetDOMElementType("submenus"), this.dom.submenuItems.forEach(function (e) {
          _this6._setDOMElementType("submenuToggles", e, !1), _this6._setDOMElementType("submenus", e, !1);
        }));
      }
    }, {
      key: "_findRootMenu",
      value: function _findRootMenu(e) {
        if (e.isTopLevel) this._elements.rootMenu = e;else if (e.elements.parentMenu !== null) this._findRootMenu(e.elements.parentMenu);else throw new Error("Cannot find root menu.");
      }
    }, {
      key: "_createChildElements",
      value: function _createChildElements() {
        var _this7 = this;
        this.dom.menuItems.forEach(function (e) {
          var t;
          if (_this7.dom.submenuItems.includes(e)) {
            var s = e.querySelector(_this7.selectors.submenuToggles),
              n = e.querySelector(_this7.selectors.submenus),
              i = new _this7._MenuType({
                menuElement: n,
                menuItemSelector: _this7.selectors.menuItems,
                menuLinkSelector: _this7.selectors.menuLinks,
                submenuItemSelector: _this7.selectors.submenuItems,
                submenuToggleSelector: _this7.selectors.submenuToggles,
                submenuSelector: _this7.selectors.submenus,
                openClass: _this7.openClass,
                closeClass: _this7.closeClass,
                transitionClass: _this7.transitionClass,
                transitionDuration: _this7.transitionDuration,
                openDuration: _this7.openDuration,
                closeDuration: _this7.closeDuration,
                isTopLevel: !1,
                parentMenu: _this7,
                hoverType: _this7.hoverType,
                hoverDelay: _this7.hoverDelay,
                enterDelay: _this7.enterDelay,
                leaveDelay: _this7.leaveDelay
              }),
              l = new _this7._MenuToggleType({
                menuToggleElement: s,
                parentElement: e,
                controlledMenu: i,
                parentMenu: _this7
              });
            _this7._elements.submenuToggles.push(l), t = new _this7._MenuItemType({
              menuItemElement: e,
              menuLinkElement: s,
              parentMenu: _this7,
              isSubmenuItem: !0,
              childMenu: i,
              toggle: l
            });
          } else {
            var _s = e.querySelector(_this7.selectors.menuLinks);
            t = new _this7._MenuItemType({
              menuItemElement: e,
              menuLinkElement: _s,
              parentMenu: _this7
            });
          }
          _this7._elements.menuItems.push(t);
        });
      }
    }, {
      key: "_clearTimeout",
      value: function _clearTimeout() {
        clearTimeout(this._hoverTimeout);
      }
    }, {
      key: "_setTimeout",
      value: function _setTimeout(e, t) {
        c("function", {
          callback: e
        }), c("number", {
          delay: t
        }), this._hoverTimeout = setTimeout(e, t);
      }
    }, {
      key: "_handleFocus",
      value: function _handleFocus() {
        var _this8 = this;
        this.elements.menuItems.forEach(function (e, t) {
          e.dom.link.addEventListener("focus", function () {
            _this8.focusState = "self", _this8.currentChild = t;
          });
        }), this.dom.menu.addEventListener("focusout", function (e) {
          _this8.currentEvent !== "keyboard" || e.relatedTarget === null || _this8.dom.menu.contains(e.relatedTarget) || (_this8.focusState = "none", _this8.closeChildren());
        });
      }
    }, {
      key: "_handleClick",
      value: function _handleClick() {
        var _this9 = this;
        function e(t, s, n) {
          o(n), n.button === 0 && (s.toggle(), s.isOpen && (t.focusState = "self", s.elements.controlledMenu.focusState = "none"));
        }
        this.elements.menuItems.forEach(function (t, s) {
          t.dom.link.addEventListener("pointerdown", function () {
            _this9.currentEvent = "mouse", _this9.elements.rootMenu.blurChildren(), _this9._clearTimeout(), _this9.focusChild(s);
          }, {
            passive: !0
          }), t.isSubmenuItem && t.elements.toggle.dom.toggle.addEventListener("pointerup", function (n) {
            _this9.currentEvent = "mouse", e(_this9, t.elements.toggle, n);
          });
        }), this.isTopLevel && this.elements.controller && this.elements.controller.dom.toggle.addEventListener("pointerup", function (t) {
          _this9.currentEvent = "mouse", e(_this9, _this9.elements.controller, t);
        }), document.addEventListener("pointerup", function (t) {
          _this9.focusState !== "none" && (_this9.currentEvent = "mouse", !_this9.dom.menu.contains(t.target) && !_this9.dom.menu !== t.target && (_this9.elements.rootMenu.hasOpened = _this9.elements.submenuToggles.some(function (s) {
            return s.isOpen;
          })));
        });
      }
    }, {
      key: "_handleHover",
      value: function _handleHover() {
        var _this0 = this;
        this.elements.menuItems.forEach(function (e, t) {
          e.dom.link.addEventListener("pointerenter", function (s) {
            s.pointerType === "pen" || s.pointerType === "touch" || (_this0.hoverType === "on" ? (_this0.currentEvent = "mouse", _this0.elements.rootMenu.blurChildren(), _this0.focusChild(t), e.isSubmenuItem && (_this0.enterDelay > 0 ? (_this0._clearTimeout(), _this0._setTimeout(function () {
              e.elements.toggle.preview();
            }, _this0.enterDelay)) : e.elements.toggle.preview())) : _this0.hoverType === "dynamic" && (_this0.currentChild = t, (!_this0.isTopLevel || _this0.focusState !== "none") && (_this0.currentEvent = "mouse", _this0.elements.rootMenu.blurChildren(), _this0.focusCurrentChild()), (!_this0.isTopLevel || _this0.hasOpened) && (_this0.currentEvent = "mouse", _this0.elements.rootMenu.blurChildren(), _this0.focusCurrentChild(), e.isSubmenuItem ? _this0.enterDelay > 0 ? (_this0._clearTimeout(), _this0._setTimeout(function () {
              e.elements.toggle.preview();
            }, _this0.enterDelay)) : e.elements.toggle.preview() : _this0.enterDelay > 0 ? (_this0._clearTimeout(), _this0._setTimeout(function () {
              _this0.closeChildren();
            }, _this0.enterDelay)) : _this0.closeChildren())));
          }), e.isSubmenuItem && (e.dom.item.addEventListener("pointerleave", function (s) {
            s.pointerType === "pen" || s.pointerType === "touch" || (_this0.hoverType === "on" ? _this0.leaveDelay > 0 ? (_this0._clearTimeout(), _this0._setTimeout(function () {
              _this0.currentEvent = "mouse", e.elements.toggle.close();
            }, _this0.leaveDelay)) : (_this0.currentEvent = "mouse", e.elements.toggle.close()) : _this0.hoverType === "dynamic" && (_this0.leaveDelay > 0 ? (_this0._clearTimeout(), _this0._setTimeout(function () {
              _this0.currentEvent = "mouse";
            }, _this0.leaveDelay)) : _this0.currentEvent = "mouse"));
          }), e.dom.item.addEventListener("pointerenter", function (s) {
            s.pointerType === "pen" || s.pointerType === "touch" || e.isSubmenuItem && (_this0.hoverType === "on" || _this0.hoverType === "dynamic") && _this0.leaveDelay > 0 && _this0._clearTimeout();
          }));
        });
      }
    }, {
      key: "_handleKeydown",
      value: function _handleKeydown() {
        var _this1 = this;
        this.isTopLevel && this.elements.controller && this.elements.controller.dom.toggle.addEventListener("keydown", function (e) {
          _this1.currentEvent = "keyboard";
          var t = b(e);
          (t === "Space" || t === "Enter") && o(e);
        });
      }
    }, {
      key: "_handleKeyup",
      value: function _handleKeyup() {
        var _this10 = this;
        this.isTopLevel && this.elements.controller && this.elements.controller.dom.toggle.addEventListener("keyup", function (e) {
          _this10.currentEvent = "keyboard";
          var t = b(e);
          (t === "Space" || t === "Enter") && (o(e), _this10.elements.controller.toggle(), _this10.elements.controller.isOpen && _this10.focusFirstChild());
        });
      }
    }, {
      key: "_setTransitionDurations",
      value: function _setTransitionDurations() {
        this.dom.menu.style.setProperty("--".concat(this.prefix, "transition-duration"), "".concat(this.transitionDuration, "ms")), this.dom.menu.style.setProperty("--".concat(this.prefix, "open-transition-duration"), "".concat(this.openDuration, "ms")), this.dom.menu.style.setProperty("--".concat(this.prefix, "close-transition-duration"), "".concat(this.closeDuration, "ms"));
      }
    }, {
      key: "focus",
      value: function focus() {
        this.focusState = "self", this.shouldFocus && this.dom.menu.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.focusState = "none", this.shouldFocus && this.dom.menu.blur();
      }
    }, {
      key: "focusCurrentChild",
      value: function focusCurrentChild() {
        this.focusState = "self", this.currentChild !== -1 && this.currentMenuItem.focus();
      }
    }, {
      key: "focusChild",
      value: function focusChild(e) {
        this.blurCurrentChild(), this.currentChild = e, this.focusCurrentChild();
      }
    }, {
      key: "focusFirstChild",
      value: function focusFirstChild() {
        this.focusChild(0);
      }
    }, {
      key: "focusLastChild",
      value: function focusLastChild() {
        this.focusChild(this.elements.menuItems.length - 1);
      }
    }, {
      key: "focusNextChild",
      value: function focusNextChild() {
        this.currentChild < this.elements.menuItems.length - 1 ? this.focusChild(this.currentChild + 1) : this.focusCurrentChild();
      }
    }, {
      key: "focusPreviousChild",
      value: function focusPreviousChild() {
        this.currentChild > 0 ? this.focusChild(this.currentChild - 1) : this.focusCurrentChild();
      }
    }, {
      key: "blurCurrentChild",
      value: function blurCurrentChild() {
        this.focusState = "none", this.currentChild !== -1 && this.currentMenuItem.blur();
      }
    }, {
      key: "focusController",
      value: function focusController() {
        this.dom.controller && (this.shouldFocus && this.dom.controller.focus(), this.focusState = "none");
      }
    }, {
      key: "focusContainer",
      value: function focusContainer() {
        this.dom.container && (this.shouldFocus && this.dom.container.focus(), this.focusState = "none");
      }
    }, {
      key: "closeChildren",
      value: function closeChildren() {
        this.elements.submenuToggles.forEach(function (e) {
          return e.close();
        });
      }
    }, {
      key: "blurChildren",
      value: function blurChildren() {
        this.elements.menuItems.forEach(function (e) {
          e.blur(), e.isSubmenuItem && e.elements.childMenu.blurChildren();
        });
      }
    }]);
  }();
  var R = /*#__PURE__*/function (_O) {
    function R(_ref4) {
      var _this11;
      var e = _ref4.menuItemElement,
        t = _ref4.menuLinkElement,
        s = _ref4.parentMenu,
        _ref4$isSubmenuItem = _ref4.isSubmenuItem,
        n = _ref4$isSubmenuItem === void 0 ? !1 : _ref4$isSubmenuItem,
        _ref4$childMenu = _ref4.childMenu,
        i = _ref4$childMenu === void 0 ? null : _ref4$childMenu,
        _ref4$toggle = _ref4.toggle,
        l = _ref4$toggle === void 0 ? null : _ref4$toggle,
        _ref4$initialize = _ref4.initialize,
        h = _ref4$initialize === void 0 ? !0 : _ref4$initialize;
      _classCallCheck(this, R);
      _this11 = _callSuper(this, R, [{
        menuItemElement: e,
        menuLinkElement: t,
        parentMenu: s,
        isSubmenuItem: n,
        childMenu: i,
        toggle: l
      }]), h && _this11.initialize();
      return _this11;
    }
    _inherits(R, _O);
    return _createClass(R);
  }(O);
  var U = /*#__PURE__*/function (_L) {
    function U(_ref5) {
      var _this12;
      var e = _ref5.menuToggleElement,
        t = _ref5.parentElement,
        s = _ref5.controlledMenu,
        _ref5$parentMenu = _ref5.parentMenu,
        n = _ref5$parentMenu === void 0 ? null : _ref5$parentMenu,
        _ref5$initialize = _ref5.initialize,
        i = _ref5$initialize === void 0 ? !0 : _ref5$initialize;
      _classCallCheck(this, U);
      _this12 = _callSuper(this, U, [{
        menuToggleElement: e,
        parentElement: t,
        controlledMenu: s,
        parentMenu: n
      }]), i && _this12.initialize();
      return _this12;
    }
    _inherits(U, _L);
    return _createClass(U, [{
      key: "_setAriaAttributes",
      value: function _setAriaAttributes() {
        _superPropGet(U, "_setAriaAttributes", this, 3)([]), K("button", {
          toggle: this.dom.toggle
        }) || this.dom.toggle.setAttribute("role", "button"), this.dom.toggle.setAttribute("aria-controls", this.elements.controlledMenu.dom.menu.id);
      }
    }, {
      key: "open",
      value: function open() {
        this.closeSiblings(), _superPropGet(U, "open", this, 3)([]);
      }
    }, {
      key: "preview",
      value: function preview() {
        this.closeSiblings(), _superPropGet(U, "preview", this, 3)([]);
      }
    }, {
      key: "close",
      value: function close() {
        this.isOpen && this.closeChildren(), _superPropGet(U, "close", this, 3)([]);
      }
    }]);
  }(L);
  var $ = /*#__PURE__*/function (_k) {
    function $(_ref6) {
      var _this13;
      var t = _ref6.menuElement,
        _ref6$menuItemSelecto = _ref6.menuItemSelector,
        s = _ref6$menuItemSelecto === void 0 ? "li" : _ref6$menuItemSelecto,
        _ref6$menuLinkSelecto = _ref6.menuLinkSelector,
        n = _ref6$menuLinkSelecto === void 0 ? "a" : _ref6$menuLinkSelecto,
        _ref6$submenuItemSele = _ref6.submenuItemSelector,
        i = _ref6$submenuItemSele === void 0 ? "li:has(ul)" : _ref6$submenuItemSele,
        _ref6$submenuToggleSe = _ref6.submenuToggleSelector,
        l = _ref6$submenuToggleSe === void 0 ? "button" : _ref6$submenuToggleSe,
        _ref6$submenuSelector = _ref6.submenuSelector,
        h = _ref6$submenuSelector === void 0 ? "ul" : _ref6$submenuSelector,
        _ref6$controllerEleme = _ref6.controllerElement,
        m = _ref6$controllerEleme === void 0 ? null : _ref6$controllerEleme,
        _ref6$containerElemen = _ref6.containerElement,
        a = _ref6$containerElemen === void 0 ? null : _ref6$containerElemen,
        _ref6$openClass = _ref6.openClass,
        p = _ref6$openClass === void 0 ? "show" : _ref6$openClass,
        _ref6$closeClass = _ref6.closeClass,
        f = _ref6$closeClass === void 0 ? "hide" : _ref6$closeClass,
        _ref6$transitionClass = _ref6.transitionClass,
        g = _ref6$transitionClass === void 0 ? "transitioning" : _ref6$transitionClass,
        _ref6$transitionDurat = _ref6.transitionDuration,
        d = _ref6$transitionDurat === void 0 ? 250 : _ref6$transitionDurat,
        _ref6$openDuration = _ref6.openDuration,
        T = _ref6$openDuration === void 0 ? -1 : _ref6$openDuration,
        _ref6$closeDuration = _ref6.closeDuration,
        C = _ref6$closeDuration === void 0 ? -1 : _ref6$closeDuration,
        _ref6$isTopLevel = _ref6.isTopLevel,
        E = _ref6$isTopLevel === void 0 ? !0 : _ref6$isTopLevel,
        _ref6$parentMenu = _ref6.parentMenu,
        v = _ref6$parentMenu === void 0 ? null : _ref6$parentMenu,
        _ref6$hoverType = _ref6.hoverType,
        I = _ref6$hoverType === void 0 ? "off" : _ref6$hoverType,
        _ref6$hoverDelay = _ref6.hoverDelay,
        w = _ref6$hoverDelay === void 0 ? 250 : _ref6$hoverDelay,
        _ref6$enterDelay = _ref6.enterDelay,
        S = _ref6$enterDelay === void 0 ? -1 : _ref6$enterDelay,
        _ref6$leaveDelay = _ref6.leaveDelay,
        D = _ref6$leaveDelay === void 0 ? -1 : _ref6$leaveDelay,
        _ref6$optionalKeySupp = _ref6.optionalKeySupport,
        q = _ref6$optionalKeySupp === void 0 ? !1 : _ref6$optionalKeySupp,
        _ref6$prefix = _ref6.prefix,
        j = _ref6$prefix === void 0 ? "am-" : _ref6$prefix,
        _ref6$initialize = _ref6.initialize,
        X = _ref6$initialize === void 0 ? !0 : _ref6$initialize;
      _classCallCheck(this, $);
      _this13 = _callSuper(this, $, [{
        menuElement: t,
        menuItemSelector: s,
        menuLinkSelector: n,
        submenuItemSelector: i,
        submenuToggleSelector: l,
        submenuSelector: h,
        controllerElement: m,
        containerElement: a,
        openClass: p,
        closeClass: f,
        transitionClass: g,
        transitionDuration: d,
        openDuration: T,
        closeDuration: C,
        isTopLevel: E,
        parentMenu: v,
        hoverType: I,
        hoverDelay: w,
        enterDelay: S,
        leaveDelay: D,
        prefix: j
      }]);
      u(_this13, "_MenuType", $);
      u(_this13, "_MenuItemType", R);
      u(_this13, "_MenuToggleType", U);
      u(_this13, "_currentChild", -1);
      u(_this13, "_optionalSupport", !1);
      _this13._optionalSupport = q, X && _this13.initialize();
      return _this13;
    }
    _inherits($, _k);
    return _createClass($, [{
      key: "initialize",
      value: function initialize() {
        try {
          _superPropGet($, "initialize", this, 3)([]), this._handleFocus(), this._handleClick(), this._handleHover(), this._handleKeydown(), this._handleKeyup();
        } catch (t) {
          console.error(t);
        }
      }
    }, {
      key: "optionalKeySupport",
      get: function get() {
        return this.isTopLevel ? this._optionalSupport : this.elements.rootMenu.optionalKeySupport;
      },
      set: function set(t) {
        c("boolean", {
          optionalKeySupport: t
        }), this._optionalSupport = t;
      }
    }, {
      key: "_validate",
      value: function _validate() {
        var t = _superPropGet($, "_validate", this, 3)([]);
        var s = c("boolean", {
          optionalKeySupport: this._optionalSupport
        });
        return s.status || (this._errors.push(s.error.message), t = !1), t;
      }
    }, {
      key: "_handleClick",
      value: function _handleClick() {
        var _this14 = this;
        _superPropGet($, "_handleClick", this, 3)([]), document.addEventListener("pointerup", function (t) {
          _this14.focusState !== "none" && (_this14.currentEvent = "mouse", !_this14.dom.menu.contains(t.target) && !_this14.dom.menu !== t.target && (_this14.closeChildren(), _this14.blur(), _this14.elements.controller && _this14.elements.controller.close(), _this14.elements.rootMenu.hasOpened = !1));
        });
      }
    }, {
      key: "_handleKeydown",
      value: function _handleKeydown() {
        var _this15 = this;
        _superPropGet($, "_handleKeydown", this, 3)([]), this.dom.menu.addEventListener("keydown", function (t) {
          _this15.currentEvent = "keyboard";
          var s = b(t);
          if (_this15.focusState === "self") {
            var n = ["Space", "Enter"],
              i = ["Escape"],
              l = ["Escape"],
              h = ["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Home", "End"];
            (n.includes(s) || _this15.optionalKeySupport && h.includes(s) || _this15.elements.controller && i.includes(s) || _this15.elements.parentMenu && l.includes(s)) && o(t);
          }
        });
      }
    }, {
      key: "_handleKeyup",
      value: function _handleKeyup() {
        var _this16 = this;
        _superPropGet($, "_handleKeyup", this, 3)([]), this.dom.menu.addEventListener("keyup", function (t) {
          _this16.currentEvent = "keyboard";
          var s = b(t);
          _this16.focusState === "self" && (s === "Space" || s === "Enter" ? (o(t), _this16.currentMenuItem.isSubmenuItem ? _this16.currentMenuItem.elements.toggle.isOpen ? _this16.currentMenuItem.elements.toggle.close() : _this16.currentMenuItem.elements.toggle.preview() : _this16.currentMenuItem.dom.link.click()) : s === "Escape" ? _this16.elements.submenuToggles.some(function (i) {
            return i.isOpen;
          }) ? (o(t), _this16.closeChildren()) : _this16.elements.parentMenu ? (o(t), _this16.elements.parentMenu.currentEvent = _this16.currentEvent, _this16.elements.parentMenu.closeChildren(), _this16.elements.parentMenu.focusCurrentChild()) : _this16.isTopLevel && _this16.elements.controller && _this16.elements.controller.isOpen && (_this16.elements.controller.close(), _this16.focusController()) : _this16.optionalKeySupport && (s === "ArrowDown" || s === "ArrowRight" ? (o(t), _this16.currentMenuItem.isSubmenuItem && _this16.currentMenuItem.elements.toggle.isOpen ? (_this16.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this16.currentMenuItem.elements.childMenu.focusFirstChild()) : _this16.focusNextChild()) : s === "ArrowUp" || s === "ArrowLeft" ? (o(t), _this16.focusPreviousChild()) : s === "Home" ? (o(t), _this16.focusFirstChild()) : s === "End" && (o(t), _this16.focusLastChild())));
        });
      }
    }]);
  }(k);
  var W = /*#__PURE__*/function (_O2) {
    function W(_ref7) {
      var _this17;
      var e = _ref7.menuItemElement,
        t = _ref7.menuLinkElement,
        s = _ref7.parentMenu,
        _ref7$isSubmenuItem = _ref7.isSubmenuItem,
        n = _ref7$isSubmenuItem === void 0 ? !1 : _ref7$isSubmenuItem,
        _ref7$childMenu = _ref7.childMenu,
        i = _ref7$childMenu === void 0 ? null : _ref7$childMenu,
        _ref7$toggle = _ref7.toggle,
        l = _ref7$toggle === void 0 ? null : _ref7$toggle,
        _ref7$initialize = _ref7.initialize,
        h = _ref7$initialize === void 0 ? !0 : _ref7$initialize;
      _classCallCheck(this, W);
      _this17 = _callSuper(this, W, [{
        menuItemElement: e,
        menuLinkElement: t,
        parentMenu: s,
        isSubmenuItem: n,
        childMenu: i,
        toggle: l
      }]), h && _this17.initialize();
      return _this17;
    }
    _inherits(W, _O2);
    return _createClass(W, [{
      key: "initialize",
      value: function initialize() {
        _superPropGet(W, "initialize", this, 3)([]), this.dom.item.setAttribute("role", "none"), this.dom.link.setAttribute("role", "menuitem"), this.dom.link.tabIndex = -1;
      }
    }, {
      key: "focus",
      value: function focus() {
        _superPropGet(W, "focus", this, 3)([]), this.elements.parentMenu.isTopLevel && (this.dom.link.tabIndex = 0);
      }
    }, {
      key: "blur",
      value: function blur() {
        _superPropGet(W, "blur", this, 3)([]), this.elements.parentMenu.isTopLevel && (this.dom.link.tabIndex = -1);
      }
    }]);
  }(O);
  var Z = /*#__PURE__*/function (_L2) {
    function Z(_ref8) {
      var _this18;
      var e = _ref8.menuToggleElement,
        t = _ref8.parentElement,
        s = _ref8.controlledMenu,
        _ref8$parentMenu = _ref8.parentMenu,
        n = _ref8$parentMenu === void 0 ? null : _ref8$parentMenu,
        _ref8$initialize = _ref8.initialize,
        i = _ref8$initialize === void 0 ? !0 : _ref8$initialize;
      _classCallCheck(this, Z);
      _this18 = _callSuper(this, Z, [{
        menuToggleElement: e,
        parentElement: t,
        controlledMenu: s,
        parentMenu: n
      }]), i && _this18.initialize();
      return _this18;
    }
    _inherits(Z, _L2);
    return _createClass(Z, [{
      key: "_setAriaAttributes",
      value: function _setAriaAttributes() {
        _superPropGet(Z, "_setAriaAttributes", this, 3)([]), this.dom.toggle.setAttribute("aria-haspopup", "true");
      }
    }, {
      key: "open",
      value: function open() {
        this.closeSiblings(), _superPropGet(Z, "open", this, 3)([]);
      }
    }, {
      key: "preview",
      value: function preview() {
        this.closeSiblings(), _superPropGet(Z, "preview", this, 3)([]);
      }
    }, {
      key: "close",
      value: function close() {
        this.isOpen && (this.closeChildren(), this.elements.parentMenu && this.elements.parentMenu.focusCurrentChild()), _superPropGet(Z, "close", this, 3)([]);
      }
    }]);
  }(L);
  var F = /*#__PURE__*/function (_k2) {
    function F(_ref9) {
      var _this19;
      var t = _ref9.menuElement,
        _ref9$menuItemSelecto = _ref9.menuItemSelector,
        s = _ref9$menuItemSelecto === void 0 ? "li" : _ref9$menuItemSelecto,
        _ref9$menuLinkSelecto = _ref9.menuLinkSelector,
        n = _ref9$menuLinkSelecto === void 0 ? "a" : _ref9$menuLinkSelecto,
        _ref9$submenuItemSele = _ref9.submenuItemSelector,
        i = _ref9$submenuItemSele === void 0 ? "li:has(ul)" : _ref9$submenuItemSele,
        _ref9$submenuToggleSe = _ref9.submenuToggleSelector,
        l = _ref9$submenuToggleSe === void 0 ? "a" : _ref9$submenuToggleSe,
        _ref9$submenuSelector = _ref9.submenuSelector,
        h = _ref9$submenuSelector === void 0 ? "ul" : _ref9$submenuSelector,
        _ref9$controllerEleme = _ref9.controllerElement,
        m = _ref9$controllerEleme === void 0 ? null : _ref9$controllerEleme,
        _ref9$containerElemen = _ref9.containerElement,
        a = _ref9$containerElemen === void 0 ? null : _ref9$containerElemen,
        _ref9$openClass = _ref9.openClass,
        p = _ref9$openClass === void 0 ? "show" : _ref9$openClass,
        _ref9$closeClass = _ref9.closeClass,
        f = _ref9$closeClass === void 0 ? "hide" : _ref9$closeClass,
        _ref9$transitionClass = _ref9.transitionClass,
        g = _ref9$transitionClass === void 0 ? "transitioning" : _ref9$transitionClass,
        _ref9$transitionDurat = _ref9.transitionDuration,
        d = _ref9$transitionDurat === void 0 ? 250 : _ref9$transitionDurat,
        _ref9$isTopLevel = _ref9.isTopLevel,
        T = _ref9$isTopLevel === void 0 ? !0 : _ref9$isTopLevel,
        _ref9$parentMenu = _ref9.parentMenu,
        C = _ref9$parentMenu === void 0 ? null : _ref9$parentMenu,
        _ref9$hoverType = _ref9.hoverType,
        E = _ref9$hoverType === void 0 ? "off" : _ref9$hoverType,
        _ref9$hoverDelay = _ref9.hoverDelay,
        v = _ref9$hoverDelay === void 0 ? 250 : _ref9$hoverDelay,
        _ref9$enterDelay = _ref9.enterDelay,
        I = _ref9$enterDelay === void 0 ? -1 : _ref9$enterDelay,
        _ref9$leaveDelay = _ref9.leaveDelay,
        w = _ref9$leaveDelay === void 0 ? -1 : _ref9$leaveDelay,
        _ref9$prefix = _ref9.prefix,
        S = _ref9$prefix === void 0 ? "am-" : _ref9$prefix,
        _ref9$initialize = _ref9.initialize,
        D = _ref9$initialize === void 0 ? !0 : _ref9$initialize;
      _classCallCheck(this, F);
      _this19 = _callSuper(this, F, [{
        menuElement: t,
        menuItemSelector: s,
        menuLinkSelector: n,
        submenuItemSelector: i,
        submenuToggleSelector: l,
        submenuSelector: h,
        controllerElement: m,
        containerElement: a,
        openClass: p,
        closeClass: f,
        transitionClass: g,
        transitionDuration: d,
        isTopLevel: T,
        parentMenu: C,
        hoverType: E,
        hoverDelay: v,
        enterDelay: I,
        leaveDelay: w,
        prefix: S
      }]);
      u(_this19, "_MenuType", F);
      u(_this19, "_MenuItemType", W);
      u(_this19, "_MenuToggleType", Z);
      D && _this19.initialize();
      return _this19;
    }
    _inherits(F, _k2);
    return _createClass(F, [{
      key: "initialize",
      value: function initialize() {
        try {
          _superPropGet(F, "initialize", this, 3)([]), this.isTopLevel ? this.dom.menu.setAttribute("role", "menubar") : this.dom.menu.setAttribute("role", "menu"), this._handleFocus(), this._handleClick(), this._handleHover(), this._handleKeydown(), this._handleKeyup(), this.isTopLevel && (this.elements.menuItems[0].dom.link.tabIndex = 0, this.elements.controller && this.elements.controller.dom.toggle.removeAttribute("aria-haspopup"));
        } catch (t) {
          console.error(t);
        }
      }
    }, {
      key: "_handleClick",
      value: function _handleClick() {
        var _this20 = this;
        _superPropGet(F, "_handleClick", this, 3)([]), document.addEventListener("pointerup", function (t) {
          _this20.focusState !== "none" && (_this20.currentEvent = "mouse", !_this20.dom.menu.contains(t.target) && !_this20.dom.menu !== t.target && (_this20.closeChildren(), _this20.blur(), _this20.elements.controller && _this20.elements.controller.close(), _this20.elements.rootMenu.hasOpened = !1));
        });
      }
    }, {
      key: "_handleKeydown",
      value: function _handleKeydown() {
        var _this21 = this;
        _superPropGet(F, "_handleKeydown", this, 3)([]), this.dom.menu.addEventListener("keydown", function (t) {
          _this21.currentEvent = "keyboard";
          var s = b(t);
          if (s === "Tab" && (_this21.elements.rootMenu.focusState !== "none" ? (_this21.elements.rootMenu.blur(), _this21.elements.rootMenu.closeChildren()) : _this21.elements.rootMenu.focus()), s === "Character") o(t);else if (_this21.isTopLevel) {
            if (_this21.focusState === "self") {
              var n = ["Space", "Enter", "ArrowRight", "ArrowLeft", "Home", "End"],
                i = ["ArrowDown", "ArrowUp"],
                l = ["Escape"];
              (n.includes(s) || _this21.currentMenuItem.isSubmenuItem && i.includes(s) || _this21.elements.controller && l.includes(s)) && o(t);
            }
          } else ["Space", "Enter", "Escape", "ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp", "Home", "End"].includes(s) && o(t);
        });
      }
    }, {
      key: "_handleKeyup",
      value: function _handleKeyup() {
        var _this22 = this;
        _superPropGet(F, "_handleKeyup", this, 3)([]), this.dom.menu.addEventListener("keyup", function (t) {
          _this22.currentEvent = "keyboard";
          var s = b(t),
            n = t.altKey,
            i = t.crtlKey,
            l = t.metaKey;
          if (s === "Character" && !(n || i || l)) o(t), _this22.elements.rootMenu.currentEvent = "character", _this22.focusNextChildWithCharacter(t.key);else if (_this22.isTopLevel) {
            if (_this22.focusState === "self") if (s === "Space" || s === "Enter") o(t), _this22.currentMenuItem.isSubmenuItem ? (_this22.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.currentMenuItem.elements.toggle.open(), requestAnimationFrame(function () {
              _this22.currentMenuItem.elements.childMenu.focusFirstChild();
            })) : _this22.currentMenuItem.dom.link.click();else if (s === "ArrowRight") {
              o(t);
              var m = _this22.currentMenuItem.isSubmenuItem && _this22.currentMenuItem.elements.toggle.isOpen;
              _this22.focusNextChild(), m && (_this22.currentMenuItem.isSubmenuItem ? (_this22.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.currentMenuItem.elements.toggle.preview()) : _this22.closeChildren());
            } else if (s === "ArrowLeft") {
              o(t);
              var _m = _this22.currentMenuItem.isSubmenuItem && _this22.currentMenuItem.elements.toggle.isOpen;
              _this22.focusPreviousChild(), _m && (_this22.currentMenuItem.isSubmenuItem ? (_this22.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.currentMenuItem.elements.toggle.preview()) : _this22.closeChildren());
            } else s === "ArrowDown" ? _this22.currentMenuItem.isSubmenuItem && (o(t), _this22.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.currentMenuItem.elements.toggle.open(), requestAnimationFrame(function () {
              _this22.currentMenuItem.elements.childMenu.focusFirstChild();
            })) : s === "ArrowUp" ? _this22.currentMenuItem.isSubmenuItem && (o(t), _this22.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.currentMenuItem.elements.toggle.open(), requestAnimationFrame(function () {
              _this22.currentMenuItem.elements.childMenu.focusLastChild();
            })) : s === "Home" ? (o(t), _this22.focusFirstChild()) : s === "End" ? (o(t), _this22.focusLastChild()) : s === "Escape" && (_this22.elements.submenuToggles.some(function (a) {
              return a.isOpen;
            }) ? (o(t), _this22.closeChildren()) : _this22.isTopLevel && _this22.elements.controller && _this22.elements.controller.isOpen && (o(t), _this22.elements.controller.close(), _this22.focusController()));
          } else s === "Space" || s === "Enter" ? (o(t), _this22.currentMenuItem.isSubmenuItem ? (_this22.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.currentMenuItem.elements.toggle.open(), requestAnimationFrame(function () {
            _this22.currentMenuItem.elements.childMenu.focusFirstChild();
          })) : _this22.currentMenuItem.dom.link.click()) : s === "Escape" ? (o(t), _this22.elements.rootMenu.closeChildren(), _this22.elements.rootMenu.focusCurrentChild()) : s === "ArrowRight" ? _this22.currentMenuItem.isSubmenuItem ? (o(t), _this22.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.currentMenuItem.elements.toggle.open(), requestAnimationFrame(function () {
            _this22.currentMenuItem.elements.childMenu.focusFirstChild();
          })) : (o(t), _this22.elements.rootMenu.closeChildren(), _this22.elements.rootMenu.focusNextChild(), _this22.elements.rootMenu.currentMenuItem.isSubmenuItem && _this22.elements.rootMenu.currentMenuItem.elements.toggle.preview()) : s === "ArrowLeft" ? _this22.elements.parentMenu.currentMenuItem.isSubmenuItem && (o(t), _this22.elements.parentMenu.currentMenuItem.elements.toggle.close(), _this22.elements.parentMenu.focusCurrentChild(), _this22.elements.parentMenu === _this22.elements.rootMenu && (_this22.elements.rootMenu.closeChildren(), _this22.elements.rootMenu.focusPreviousChild(), _this22.elements.rootMenu.currentMenuItem.isSubmenuItem && (_this22.elements.rootMenu.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this22.elements.rootMenu.currentMenuItem.elements.toggle.preview()))) : s === "ArrowDown" ? (o(t), _this22.focusNextChild()) : s === "ArrowUp" ? (o(t), _this22.focusPreviousChild()) : s === "Home" ? (o(t), _this22.focusFirstChild()) : s === "End" && (o(t), _this22.focusLastChild());
        });
      }
    }, {
      key: "focusNextChild",
      value: function focusNextChild() {
        this.currentChild === this.elements.menuItems.length - 1 ? this.focusFirstChild() : this.focusChild(this.currentChild + 1);
      }
    }, {
      key: "focusPreviousChild",
      value: function focusPreviousChild() {
        this.currentChild === 0 ? this.focusLastChild() : this.focusChild(this.currentChild - 1);
      }
    }, {
      key: "focusNextChildWithCharacter",
      value: function focusNextChildWithCharacter(t) {
        var s = t.toLowerCase();
        var n = this.currentChild + 1,
          i = !1;
        for (; !i && n < this.elements.menuItems.length;) {
          var l = "";
          this.elements.menuItems[n].dom.item.innerText ? l = this.elements.menuItems[n].dom.item.innerText : l = this.elements.menuItems[n].dom.item.textContent, l = l.replace(/[\s]/g, "").toLowerCase().charAt(0), l === s && (i = !0, this.focusChild(n)), n++;
        }
      }
    }]);
  }(k);
  var Q = /*#__PURE__*/function (_O3) {
    function Q(_ref0) {
      var _this23;
      var t = _ref0.menuItemElement,
        s = _ref0.menuLinkElement,
        n = _ref0.parentMenu,
        _ref0$isSubmenuItem = _ref0.isSubmenuItem,
        i = _ref0$isSubmenuItem === void 0 ? !1 : _ref0$isSubmenuItem,
        _ref0$childMenu = _ref0.childMenu,
        l = _ref0$childMenu === void 0 ? null : _ref0$childMenu,
        _ref0$toggle = _ref0.toggle,
        h = _ref0$toggle === void 0 ? null : _ref0$toggle,
        _ref0$initialize = _ref0.initialize,
        m = _ref0$initialize === void 0 ? !0 : _ref0$initialize,
        _ref0$submenuSibling = _ref0.submenuSibling,
        a = _ref0$submenuSibling === void 0 ? null : _ref0$submenuSibling;
      _classCallCheck(this, Q);
      _this23 = _callSuper(this, Q, [{
        menuItemElement: t,
        menuLinkElement: s,
        parentMenu: n,
        isSubmenuItem: i,
        childMenu: l,
        toggle: h
      }]);
      u(_this23, "_elements", {
        parentMenu: null,
        childMenu: null,
        toggle: null,
        sibling: null
      });
      _this23._elements.parentMenu = n, _this23._elements.childMenu = l, _this23._elements.toggle = h, _this23._elements.sibling = a, m && _this23.initialize();
      return _this23;
    }
    _inherits(Q, _O3);
    return _createClass(Q);
  }(O);
  var B = /*#__PURE__*/function (_L3) {
    function B(_ref1) {
      var _this24;
      var e = _ref1.menuToggleElement,
        t = _ref1.parentElement,
        s = _ref1.controlledMenu,
        _ref1$parentMenu = _ref1.parentMenu,
        n = _ref1$parentMenu === void 0 ? null : _ref1$parentMenu,
        _ref1$initialize = _ref1.initialize,
        i = _ref1$initialize === void 0 ? !0 : _ref1$initialize;
      _classCallCheck(this, B);
      _this24 = _callSuper(this, B, [{
        menuToggleElement: e,
        parentElement: t,
        controlledMenu: s,
        parentMenu: n
      }]), i && _this24.initialize();
      return _this24;
    }
    _inherits(B, _L3);
    return _createClass(B, [{
      key: "_setAriaAttributes",
      value: function _setAriaAttributes() {
        _superPropGet(B, "_setAriaAttributes", this, 3)([]), K("button", {
          toggle: this.dom.toggle
        }) || this.dom.toggle.setAttribute("role", "button"), this.dom.toggle.setAttribute("aria-controls", this.elements.controlledMenu.dom.menu.id);
      }
    }, {
      key: "open",
      value: function open() {
        this.closeSiblings(), _superPropGet(B, "open", this, 3)([]);
      }
    }, {
      key: "preview",
      value: function preview() {
        this.closeSiblings(), _superPropGet(B, "preview", this, 3)([]);
      }
    }, {
      key: "close",
      value: function close() {
        this.isOpen && this.closeChildren(), _superPropGet(B, "close", this, 3)([]);
      }
    }]);
  }(L);
  var z = /*#__PURE__*/function (_k3) {
    function z(_ref10) {
      var _this25;
      var t = _ref10.menuElement,
        _ref10$menuItemSelect = _ref10.menuItemSelector,
        s = _ref10$menuItemSelect === void 0 ? "li" : _ref10$menuItemSelect,
        _ref10$menuLinkSelect = _ref10.menuLinkSelector,
        n = _ref10$menuLinkSelect === void 0 ? "a" : _ref10$menuLinkSelect,
        _ref10$submenuItemSel = _ref10.submenuItemSelector,
        i = _ref10$submenuItemSel === void 0 ? "li:has(ul)" : _ref10$submenuItemSel,
        _ref10$submenuToggleS = _ref10.submenuToggleSelector,
        l = _ref10$submenuToggleS === void 0 ? "button" : _ref10$submenuToggleS,
        _ref10$submenuSelecto = _ref10.submenuSelector,
        h = _ref10$submenuSelecto === void 0 ? "ul" : _ref10$submenuSelecto,
        _ref10$submenuSubtogg = _ref10.submenuSubtoggleSelector,
        m = _ref10$submenuSubtogg === void 0 ? "a" : _ref10$submenuSubtogg,
        _ref10$controllerElem = _ref10.controllerElement,
        a = _ref10$controllerElem === void 0 ? null : _ref10$controllerElem,
        _ref10$containerEleme = _ref10.containerElement,
        p = _ref10$containerEleme === void 0 ? null : _ref10$containerEleme,
        _ref10$openClass = _ref10.openClass,
        f = _ref10$openClass === void 0 ? "show" : _ref10$openClass,
        _ref10$closeClass = _ref10.closeClass,
        g = _ref10$closeClass === void 0 ? "hide" : _ref10$closeClass,
        _ref10$transitionClas = _ref10.transitionClass,
        d = _ref10$transitionClas === void 0 ? "transitioning" : _ref10$transitionClas,
        _ref10$transitionDura = _ref10.transitionDuration,
        T = _ref10$transitionDura === void 0 ? 250 : _ref10$transitionDura,
        _ref10$isTopLevel = _ref10.isTopLevel,
        C = _ref10$isTopLevel === void 0 ? !0 : _ref10$isTopLevel,
        _ref10$parentMenu = _ref10.parentMenu,
        E = _ref10$parentMenu === void 0 ? null : _ref10$parentMenu,
        _ref10$hoverType = _ref10.hoverType,
        v = _ref10$hoverType === void 0 ? "off" : _ref10$hoverType,
        _ref10$hoverDelay = _ref10.hoverDelay,
        I = _ref10$hoverDelay === void 0 ? 250 : _ref10$hoverDelay,
        _ref10$enterDelay = _ref10.enterDelay,
        w = _ref10$enterDelay === void 0 ? -1 : _ref10$enterDelay,
        _ref10$leaveDelay = _ref10.leaveDelay,
        S = _ref10$leaveDelay === void 0 ? -1 : _ref10$leaveDelay,
        _ref10$optionalKeySup = _ref10.optionalKeySupport,
        D = _ref10$optionalKeySup === void 0 ? !1 : _ref10$optionalKeySup,
        _ref10$prefix = _ref10.prefix,
        q = _ref10$prefix === void 0 ? "am-" : _ref10$prefix,
        _ref10$initialize = _ref10.initialize,
        j = _ref10$initialize === void 0 ? !0 : _ref10$initialize;
      _classCallCheck(this, z);
      _this25 = _callSuper(this, z, [{
        menuElement: t,
        menuItemSelector: s,
        menuLinkSelector: n,
        submenuItemSelector: i,
        submenuSelector: h,
        submenuToggleSelector: l,
        controllerElement: a,
        containerElement: p,
        openClass: f,
        closeClass: g,
        transitionClass: d,
        transitionDuration: T,
        isTopLevel: C,
        parentMenu: E,
        hoverType: v,
        hoverDelay: I,
        enterDelay: w,
        leaveDelay: S,
        prefix: q
      }]);
      u(_this25, "_MenuType", z);
      u(_this25, "_MenuItemType", Q);
      u(_this25, "_MenuToggleType", B);
      u(_this25, "_currentChild", -1);
      u(_this25, "_selectors", {
        menuItems: "",
        menuLinks: "",
        submenuItems: "",
        submenuToggles: "",
        submenus: "",
        submenuSubtoggles: ""
      });
      u(_this25, "_optionalSupport", !1);
      _this25._optionalSupport = D, _this25._selectors.menuItems = s, _this25._selectors.submenuItems = i, _this25._selectors.submenuToggles = l, _this25._selectors.submenus = h, _this25._selectors.submenuSubtoggles = m, _this25._selectors.menuLinks = _toConsumableArray(new Set([n, l])).join(","), j && _this25.initialize();
      return _this25;
    }
    _inherits(z, _k3);
    return _createClass(z, [{
      key: "initialize",
      value: function initialize() {
        try {
          _superPropGet(z, "initialize", this, 3)([]), this._handleFocus(), this._handleClick(), this._handleHover(), this._handleKeydown(), this._handleKeyup();
        } catch (t) {
          console.error(t);
        }
      }
    }, {
      key: "optionalKeySupport",
      get: function get() {
        return this.isTopLevel ? this._optionalSupport : this.elements.rootMenu.optionalKeySupport;
      },
      set: function set(t) {
        c("boolean", {
          optionalKeySupport: t
        }), this._optionalSupport = t;
      }
    }, {
      key: "_createChildElements",
      value: function _createChildElements() {
        var _this26 = this;
        this.dom.menuItems.forEach(function (t) {
          var s, n;
          var i = t.querySelector(_this26.selectors.menuLinks);
          if (_this26.dom.submenuItems.includes(t)) {
            var l = t.querySelector(_this26.selectors.submenuToggles),
              h = t.querySelector(_this26.selectors.submenus),
              m = new _this26._MenuType({
                menuElement: h,
                menuItemSelector: _this26.selectors.menuItems,
                menuLinkSelector: _this26.selectors.menuLinks,
                submenuItemSelector: _this26.selectors.submenuItems,
                submenuToggleSelector: _this26.selectors.submenuSubtoggles,
                submenuSelector: _this26.selectors.submenus,
                submenuSubtoggleSelector: _this26.selectors.submenuSubtoggles,
                openClass: _this26.openClass,
                closeClass: _this26.closeClass,
                transitionClass: _this26.transitionClass,
                isTopLevel: !1,
                parentMenu: _this26,
                hoverType: _this26.hoverType,
                hoverDelay: _this26.hoverDelay,
                enterDelay: _this26.enterDelay,
                leaveDelay: _this26.leaveDelay
              }),
              a = new _this26._MenuToggleType({
                menuToggleElement: l,
                parentElement: t,
                controlledMenu: m,
                parentMenu: _this26
              });
            _this26._elements.submenuToggles.push(a), l !== i ? (n = new _this26._MenuItemType({
              menuItemElement: t,
              menuLinkElement: l,
              parentMenu: _this26,
              isSubmenuItem: !0,
              childMenu: m,
              toggle: a
            }), s = new _this26._MenuItemType({
              menuItemElement: t,
              menuLinkElement: i,
              parentMenu: _this26,
              submenuSibling: n
            })) : s = new _this26._MenuItemType({
              menuItemElement: t,
              menuLinkElement: i,
              parentMenu: _this26,
              isSubmenuItem: !0,
              childMenu: m,
              toggle: a
            });
          } else s = new _this26._MenuItemType({
            menuItemElement: t,
            menuLinkElement: i,
            parentMenu: _this26
          });
          _this26._elements.menuItems.push(s), _typeof(n) < "u" && _this26._elements.menuItems.push(n);
        });
      }
    }, {
      key: "_validate",
      value: function _validate() {
        var t = _superPropGet(z, "_validate", this, 3)([]);
        var s = x({
          submenuSubtoggleSelector: this._selectors.submenuSubtoggles
        });
        s.status || (this._errors.push(s.error.message), t = !1);
        var n = c("boolean", {
          optionalKeySupport: this._optionalSupport
        });
        return n.status || (this._errors.push(n.error.message), t = !1), t;
      }
    }, {
      key: "_handleClick",
      value: function _handleClick() {
        var _this27 = this;
        _superPropGet(z, "_handleClick", this, 3)([]), document.addEventListener("pointerup", function (t) {
          _this27.focusState !== "none" && (_this27.currentEvent = "mouse", !_this27.dom.menu.contains(t.target) && !_this27.dom.menu !== t.target && (_this27.closeChildren(), _this27.blur(), _this27.elements.controller && _this27.elements.controller.close(), _this27.elements.rootMenu.hasOpened = !1));
        });
      }
    }, {
      key: "_handleHover",
      value: function _handleHover() {
        var _this28 = this;
        this.elements.menuItems.forEach(function (t, s) {
          t.dom.link.addEventListener("pointerenter", function (n) {
            if (!(n.pointerType === "pen" || n.pointerType === "touch")) {
              if (_this28.hoverType === "on") {
                _this28.currentEvent = "mouse", _this28.elements.rootMenu.blurChildren(), _this28.focusChild(s);
                var i = t.isSubmenuItem ? t.elements.toggle : null;
                if (t.elements.sibling !== null && (i = t.elements.sibling.elements.toggle), i === null) return;
                _this28.enterDelay > 0 ? (_this28._clearTimeout(), _this28._setTimeout(function () {
                  i.preview();
                }, _this28.enterDelay)) : i.preview();
              } else if (_this28.hoverType === "dynamic" && (_this28.currentChild = s, (!_this28.isTopLevel || _this28.focusState !== "none") && (_this28.currentEvent = "mouse", _this28.elements.rootMenu.blurChildren(), _this28.focusCurrentChild()), !_this28.isTopLevel || _this28.hasOpened)) {
                _this28.currentEvent = "mouse", _this28.elements.rootMenu.blurChildren(), _this28.focusCurrentChild();
                var _i = t.isSubmenuItem ? t.elements.toggle : null;
                t.elements.sibling !== null && (_i = t.elements.sibling.elements.toggle), _i !== null ? _this28.enterDelay > 0 ? (_this28._clearTimeout(), _this28._setTimeout(function () {
                  _i.preview();
                }, _this28.enterDelay)) : _i.preview() : _this28.enterDelay > 0 ? (_this28._clearTimeout(), _this28._setTimeout(function () {
                  _this28.closeChildren();
                }, _this28.enterDelay)) : _this28.closeChildren();
              }
            }
          }), t.isSubmenuItem && (t.dom.item.addEventListener("pointerleave", function (n) {
            n.pointerType === "pen" || n.pointerType === "touch" || (_this28.hoverType === "on" ? _this28.leaveDelay > 0 ? (_this28._clearTimeout(), _this28._setTimeout(function () {
              _this28.currentEvent = "mouse", t.elements.toggle.close();
            }, _this28.leaveDelay)) : (_this28.currentEvent = "mouse", t.elements.toggle.close()) : _this28.hoverType === "dynamic" && (_this28.leaveDelay > 0 ? (_this28._clearTimeout(), _this28._setTimeout(function () {
              _this28.currentEvent = "mouse";
            }, _this28.leaveDelay)) : _this28.currentEvent = "mouse"));
          }), t.dom.item.addEventListener("pointerenter", function (n) {
            n.pointerType === "pen" || n.pointerType === "touch" || t.isSubmenuItem && (_this28.hoverType === "on" || _this28.hoverType === "dynamic") && _this28.leaveDelay > 0 && _this28._clearTimeout();
          }));
        });
      }
    }, {
      key: "_handleKeydown",
      value: function _handleKeydown() {
        var _this29 = this;
        _superPropGet(z, "_handleKeydown", this, 3)([]), this.dom.menu.addEventListener("keydown", function (t) {
          _this29.currentEvent = "keyboard";
          var s = b(t);
          if (_this29.focusState === "self") {
            var n = ["Space", "Enter"],
              i = ["Escape"],
              l = ["Escape"],
              h = ["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Home", "End"];
            (n.includes(s) || _this29.optionalKeySupport && h.includes(s) || _this29.elements.controller && i.includes(s) || _this29.elements.parentMenu && l.includes(s)) && o(t);
          }
        });
      }
    }, {
      key: "_handleKeyup",
      value: function _handleKeyup() {
        var _this30 = this;
        _superPropGet(z, "_handleKeyup", this, 3)([]), this.dom.menu.addEventListener("keyup", function (t) {
          _this30.currentEvent = "keyboard";
          var s = b(t);
          _this30.focusState === "self" && (s === "Space" || s === "Enter" ? (o(t), _this30.currentMenuItem.isSubmenuItem ? _this30.currentMenuItem.elements.toggle.isOpen ? _this30.currentMenuItem.elements.toggle.close() : _this30.currentMenuItem.elements.toggle.preview() : _this30.currentMenuItem.dom.link.click()) : s === "Escape" ? _this30.elements.submenuToggles.some(function (i) {
            return i.isOpen;
          }) ? (o(t), _this30.closeChildren()) : _this30.elements.parentMenu ? (o(t), _this30.elements.parentMenu.currentEvent = _this30.currentEvent, _this30.elements.parentMenu.closeChildren(), _this30.elements.parentMenu.focusCurrentChild()) : _this30.isTopLevel && _this30.elements.controller && _this30.elements.controller.isOpen && (_this30.elements.controller.close(), _this30.focusController()) : _this30.optionalKeySupport && (s === "ArrowDown" || s === "ArrowRight" ? (o(t), _this30.currentMenuItem.isSubmenuItem && _this30.currentMenuItem.elements.toggle.isOpen ? (_this30.currentMenuItem.elements.childMenu.currentEvent = "keyboard", _this30.currentMenuItem.elements.childMenu.focusFirstChild()) : _this30.focusNextChild()) : s === "ArrowUp" || s === "ArrowLeft" ? (o(t), _this30.focusPreviousChild()) : s === "Home" ? (o(t), _this30.focusFirstChild()) : s === "End" && (o(t), _this30.focusLastChild())));
        });
      }
    }]);
  }(k);
  var G = /*#__PURE__*/function (_O4) {
    function G(_ref11) {
      var _this31;
      var e = _ref11.menuItemElement,
        t = _ref11.menuLinkElement,
        s = _ref11.parentMenu,
        _ref11$isSubmenuItem = _ref11.isSubmenuItem,
        n = _ref11$isSubmenuItem === void 0 ? !1 : _ref11$isSubmenuItem,
        _ref11$childMenu = _ref11.childMenu,
        i = _ref11$childMenu === void 0 ? null : _ref11$childMenu,
        _ref11$toggle = _ref11.toggle,
        l = _ref11$toggle === void 0 ? null : _ref11$toggle,
        _ref11$initialize = _ref11.initialize,
        h = _ref11$initialize === void 0 ? !0 : _ref11$initialize;
      _classCallCheck(this, G);
      _this31 = _callSuper(this, G, [{
        menuItemElement: e,
        menuLinkElement: t,
        parentMenu: s,
        isSubmenuItem: n,
        childMenu: i,
        toggle: l
      }]), h && _this31.initialize();
      return _this31;
    }
    _inherits(G, _O4);
    return _createClass(G, [{
      key: "initialize",
      value: function initialize() {
        _superPropGet(G, "initialize", this, 3)([]), this.dom.item.setAttribute("role", "none"), this.dom.link.setAttribute("role", "treeitem"), this.dom.link.tabIndex = -1;
      }
    }, {
      key: "focus",
      value: function focus() {
        _superPropGet(G, "focus", this, 3)([]), this.dom.link.tabIndex = 0;
      }
    }, {
      key: "blur",
      value: function blur() {
        _superPropGet(G, "blur", this, 3)([]), this.dom.link.tabIndex = -1;
      }
    }]);
  }(O);
  var J = /*#__PURE__*/function (_L4) {
    function J(_ref12) {
      var _this32;
      var e = _ref12.menuToggleElement,
        t = _ref12.parentElement,
        s = _ref12.controlledMenu,
        _ref12$parentMenu = _ref12.parentMenu,
        n = _ref12$parentMenu === void 0 ? null : _ref12$parentMenu,
        _ref12$initialize = _ref12.initialize,
        i = _ref12$initialize === void 0 ? !0 : _ref12$initialize;
      _classCallCheck(this, J);
      _this32 = _callSuper(this, J, [{
        menuToggleElement: e,
        parentElement: t,
        controlledMenu: s,
        parentMenu: n
      }]), i && _this32.initialize();
      return _this32;
    }
    _inherits(J, _L4);
    return _createClass(J, [{
      key: "initialize",
      value: function initialize() {
        this._setIds(), this._setAriaAttributes(), this.dom.toggle.getAttribute("aria-expanded") === "true" ? this.open() : this._collapse(!1);
      }
    }, {
      key: "_setAriaAttributes",
      value: function _setAriaAttributes() {
        this.dom.toggle.getAttribute("aria-expanded") !== "true" && this.dom.toggle.setAttribute("aria-expanded", "false"), this.elements.controlledMenu.dom.menu.setAttribute("aria-labelledby", this.dom.toggle.id), this.dom.toggle.setAttribute("aria-owns", this.elements.controlledMenu.dom.menu.id);
      }
    }]);
  }(L);
  var H = /*#__PURE__*/function (_k4) {
    function H(_ref13) {
      var _this33;
      var t = _ref13.menuElement,
        _ref13$menuItemSelect = _ref13.menuItemSelector,
        s = _ref13$menuItemSelect === void 0 ? "li" : _ref13$menuItemSelect,
        _ref13$menuLinkSelect = _ref13.menuLinkSelector,
        n = _ref13$menuLinkSelect === void 0 ? "a" : _ref13$menuLinkSelect,
        _ref13$submenuItemSel = _ref13.submenuItemSelector,
        i = _ref13$submenuItemSel === void 0 ? "li:has(ul)" : _ref13$submenuItemSel,
        _ref13$submenuToggleS = _ref13.submenuToggleSelector,
        l = _ref13$submenuToggleS === void 0 ? "a" : _ref13$submenuToggleS,
        _ref13$submenuSelecto = _ref13.submenuSelector,
        h = _ref13$submenuSelecto === void 0 ? "ul" : _ref13$submenuSelecto,
        _ref13$controllerElem = _ref13.controllerElement,
        m = _ref13$controllerElem === void 0 ? null : _ref13$controllerElem,
        _ref13$containerEleme = _ref13.containerElement,
        a = _ref13$containerEleme === void 0 ? null : _ref13$containerEleme,
        _ref13$openClass = _ref13.openClass,
        p = _ref13$openClass === void 0 ? "show" : _ref13$openClass,
        _ref13$closeClass = _ref13.closeClass,
        f = _ref13$closeClass === void 0 ? "hide" : _ref13$closeClass,
        _ref13$transitionClas = _ref13.transitionClass,
        g = _ref13$transitionClas === void 0 ? "transitioning" : _ref13$transitionClas,
        _ref13$transitionDura = _ref13.transitionDuration,
        d = _ref13$transitionDura === void 0 ? 250 : _ref13$transitionDura,
        _ref13$isTopLevel = _ref13.isTopLevel,
        T = _ref13$isTopLevel === void 0 ? !0 : _ref13$isTopLevel,
        _ref13$parentMenu = _ref13.parentMenu,
        C = _ref13$parentMenu === void 0 ? null : _ref13$parentMenu,
        _ref13$hoverType = _ref13.hoverType,
        E = _ref13$hoverType === void 0 ? "off" : _ref13$hoverType,
        _ref13$hoverDelay = _ref13.hoverDelay,
        v = _ref13$hoverDelay === void 0 ? 250 : _ref13$hoverDelay,
        _ref13$enterDelay = _ref13.enterDelay,
        I = _ref13$enterDelay === void 0 ? -1 : _ref13$enterDelay,
        _ref13$leaveDelay = _ref13.leaveDelay,
        w = _ref13$leaveDelay === void 0 ? -1 : _ref13$leaveDelay,
        _ref13$prefix = _ref13.prefix,
        S = _ref13$prefix === void 0 ? "am-" : _ref13$prefix,
        _ref13$initialize = _ref13.initialize,
        D = _ref13$initialize === void 0 ? !0 : _ref13$initialize;
      _classCallCheck(this, H);
      _this33 = _callSuper(this, H, [{
        menuElement: t,
        menuItemSelector: s,
        menuLinkSelector: n,
        submenuItemSelector: i,
        submenuToggleSelector: l,
        submenuSelector: h,
        controllerElement: m,
        containerElement: a,
        openClass: p,
        closeClass: f,
        transitionClass: g,
        transitionDuration: d,
        isTopLevel: T,
        parentMenu: C,
        hoverType: E,
        hoverDelay: v,
        enterDelay: I,
        leaveDelay: w,
        prefix: S
      }]);
      u(_this33, "_MenuType", H);
      u(_this33, "_MenuItemType", G);
      u(_this33, "_MenuToggleType", J);
      D && _this33.initialize();
      return _this33;
    }
    _inherits(H, _k4);
    return _createClass(H, [{
      key: "initialize",
      value: function initialize() {
        try {
          _superPropGet(H, "initialize", this, 3)([]), this.isTopLevel ? (this.dom.menu.setAttribute("role", "tree"), this.elements.menuItems[0].dom.link.tabIndex = 0) : this.dom.menu.setAttribute("role", "group"), this._handleFocus(), this._handleClick(), this._handleHover(), this._handleKeydown(), this._handleKeyup(), this.isTopLevel && this.elements.controller && this.elements.controller.dom.toggle.removeAttribute("aria-owns");
        } catch (t) {
          console.error(t);
        }
      }
    }, {
      key: "_handleHover",
      value: function _handleHover() {
        var _this34 = this;
        this.elements.menuItems.forEach(function (t, s) {
          t.dom.link.addEventListener("pointerenter", function (n) {
            n.pointerType === "pen" || n.pointerType === "touch" || (_this34.hoverType === "on" ? (_this34.currentEvent = "mouse", _this34.elements.rootMenu.blurChildren(), _this34.focusChild(s), t.isSubmenuItem && (_this34.enterDelay > 0 ? (_this34._clearTimeout(), _this34._setTimeout(function () {
              t.elements.toggle.preview();
            }, _this34.enterDelay)) : t.elements.toggle.preview())) : _this34.hoverType === "dynamic" && (_this34.currentChild = s, (!_this34.isTopLevel || _this34.focusState !== "none") && (_this34.currentEvent = "mouse", _this34.elements.rootMenu.blurChildren(), _this34.focusCurrentChild()), (!_this34.isTopLevel || _this34.hasOpened) && (_this34.currentEvent = "mouse", _this34.elements.rootMenu.blurChildren(), _this34.focusCurrentChild(), t.isSubmenuItem ? _this34.enterDelay > 0 ? (_this34._clearTimeout(), _this34._setTimeout(function () {
              t.elements.toggle.preview();
            }, _this34.enterDelay)) : t.elements.toggle.preview() : _this34.enterDelay > 0 && _this34._clearTimeout())));
          }), t.isSubmenuItem && (t.dom.item.addEventListener("pointerleave", function (n) {
            n.pointerType === "pen" || n.pointerType === "touch" || (_this34.hoverType === "on" ? _this34.leaveDelay > 0 && _this34._clearTimeout() : _this34.hoverType === "dynamic" && (_this34.leaveDelay > 0 ? (_this34._clearTimeout(), _this34._setTimeout(function () {
              _this34.currentEvent = "mouse";
            }, _this34.leaveDelay)) : _this34.currentEvent = "mouse"));
          }), t.dom.item.addEventListener("pointerenter", function (n) {
            n.pointerType === "pen" || n.pointerType === "touch" || t.isSubmenuItem && (_this34.hoverType === "on" || _this34.hoverType === "dynamic") && _this34.leaveDelay > 0 && _this34._clearTimeout();
          })), _this34.isTopLevel && _this34.dom.menu.addEventListener("pointerleave", function (n) {
            n.pointerType === "pen" || n.pointerType === "touch" || _this34.hoverType === "on" && (_this34.leaveDelay > 0 ? (_this34._clearTimeout(), _this34._setTimeout(function () {
              _this34.closeChildren(), _this34.blur();
            }, _this34.leaveDelay)) : (_this34.closeChildren(), _this34.blur()));
          });
        });
      }
    }, {
      key: "_handleKeydown",
      value: function _handleKeydown() {
        var _this35 = this;
        _superPropGet(H, "_handleKeydown", this, 3)([]), this.dom.menu.addEventListener("keydown", function (t) {
          _this35.currentEvent = "keyboard";
          var s = b(t);
          if (s === "Tab" && (_this35.elements.rootMenu.focusState !== "none" ? _this35.elements.rootMenu.blur() : _this35.elements.rootMenu.focus()), _this35.focusState === "self") {
            var n = ["Space", "Enter", "ArrowUp", "ArrowDown", "ArrowLeft", "Asterisk", "Home", "End"],
              i = ["ArrowRight"],
              l = ["Escape"];
            (n.includes(s) || _this35.currentMenuItem.isSubmenuItem && i.includes(s) || _this35.elements.controller && l.includes(s)) && o(t);
          }
        });
      }
    }, {
      key: "_handleKeyup",
      value: function _handleKeyup() {
        var _this36 = this;
        _superPropGet(H, "_handleKeyup", this, 3)([]), this.dom.menu.addEventListener("keyup", function (t) {
          _this36.currentEvent = "keyboard";
          var s = b(t),
            n = t.altKey,
            i = t.crtlKey,
            l = t.metaKey;
          if (s === "Character" && !(n || i || l)) o(t), _this36.elements.rootMenu.currentEvent = "character", _this36.focusNextNodeWithCharacter(t.key);else if (_this36.focusState === "self") if (s === "Enter" || s === "Space") o(t), _this36.currentMenuItem.isSubmenuItem ? _this36.currentMenuItem.elements.toggle.isOpen ? _this36.currentMenuItem.elements.toggle.close() : _this36.currentMenuItem.elements.toggle.preview() : _this36.currentMenuItem.dom.link.click();else if (s === "Escape") _this36.isTopLevel && _this36.elements.controller && _this36.elements.controller.isOpen && (_this36.elements.controller.close(), _this36.focusController());else if (s === "ArrowDown") o(t), _this36.currentMenuItem.isSubmenuItem && _this36.currentMenuItem.elements.toggle.isOpen ? (_this36.blurCurrentChild(), _this36.currentMenuItem.elements.childMenu.currentEvent = _this36.currentEvent, _this36.currentMenuItem.elements.childMenu.focusFirstChild()) : !_this36.isTopLevel && _this36.currentChild === _this36.elements.menuItems.length - 1 ? _this36.focusParentsNextChild() : _this36.focusNextChild();else if (s === "ArrowUp") {
            o(t);
            var m = _this36.elements.menuItems[_this36.currentChild - 1];
            m && m.isSubmenuItem && m.elements.toggle.isOpen ? (_this36.blurCurrentChild(), _this36.currentChild = _this36.currentChild - 1, _this36.currentMenuItem.elements.childMenu.currentEvent = _this36.currentEvent, _this36.focusChildsLastNode()) : !_this36.isTopLevel && _this36.currentChild === 0 ? (_this36.blurCurrentChild(), _this36.elements.parentMenu.currentEvent = _this36.currentEvent, _this36.elements.parentMenu.focusCurrentChild()) : _this36.focusPreviousChild();
          } else s === "ArrowRight" ? _this36.currentMenuItem.isSubmenuItem && (o(t), _this36.currentMenuItem.elements.toggle.isOpen ? (_this36.blurCurrentChild(), _this36.currentMenuItem.elements.childMenu.currentEvent = _this36.currentEvent, _this36.currentMenuItem.elements.childMenu.focusFirstChild()) : _this36.currentMenuItem.elements.toggle.preview()) : s === "ArrowLeft" ? (o(t), _this36.currentMenuItem.isSubmenuItem && _this36.currentMenuItem.elements.toggle.isOpen ? (_this36.currentMenuItem.elements.childMenu.blurCurrentChild(), _this36.currentMenuItem.elements.toggle.close()) : _this36.isTopLevel || (_this36.blurCurrentChild(), _this36.elements.parentMenu.currentEvent = _this36.currentEvent, _this36.elements.parentMenu.focusCurrentChild())) : s === "Home" ? (o(t), _this36.blurCurrentChild(), _this36.elements.rootMenu.focusFirstChild()) : s === "End" ? (o(t), _this36.blurCurrentChild(), _this36.elements.rootMenu.focusLastNode()) : s === "Asterisk" && (o(t), _this36.openChildren());
        });
      }
    }, {
      key: "focusLastNode",
      value: function focusLastNode() {
        var t = this.elements.menuItems.length - 1,
          s = this.elements.menuItems[t];
        s.isSubmenuItem && s.elements.toggle.isOpen ? (this.currentChild = t, s.elements.childMenu.currentEvent = this.currentEvent, s.elements.childMenu.focusLastNode()) : this.focusLastChild();
      }
    }, {
      key: "openChildren",
      value: function openChildren() {
        this.elements.submenuToggles.forEach(function (t) {
          return t.preview();
        });
      }
    }, {
      key: "focusNextNodeWithCharacter",
      value: function focusNextNodeWithCharacter(t) {
        function s(p) {
          var f = [];
          return p.elements.menuItems.forEach(function (g) {
            f.push(g), g.isSubmenuItem && g.elements.toggle.isOpen && (f = [].concat(_toConsumableArray(f), _toConsumableArray(s(g.elements.toggle.elements.controlledMenu))));
          }), f;
        }
        var n = t.toLowerCase(),
          i = s(this.elements.rootMenu),
          l = i.indexOf(this.currentMenuItem) + 1,
          h = [].concat(_toConsumableArray(i.slice(l)), _toConsumableArray(i.slice(0, l)));
        var m = 0,
          a = !1;
        for (; !a && m < h.length;) {
          var p = "";
          if (h[m].dom.item.innerText ? p = h[m].dom.item.innerText : p = h[m].dom.item.textContent, p = p.replace(/[\s]/g, "").toLowerCase().charAt(0), p === n) {
            a = !0;
            var f = h[m].elements.parentMenu,
              g = f.elements.menuItems.indexOf(h[m]);
            this.elements.rootMenu.blurChildren(), f.focusChild(g);
          }
          m++;
        }
      }
    }, {
      key: "focusParentsNextChild",
      value: function focusParentsNextChild() {
        this.elements.parentMenu && (this.elements.parentMenu.currentEvent = this.currentEvent, this.elements.parentMenu.currentChild === this.elements.parentMenu.elements.menuItems.length - 1 ? (this.elements.parentMenu.blurCurrentChild(), this.elements.parentMenu.focusParentsNextChild()) : (this.blurChildren(), this.elements.parentMenu.focusNextChild()));
      }
    }, {
      key: "focusChildsLastNode",
      value: function focusChildsLastNode() {
        this.currentMenuItem.elements.childMenu.currentEvent = this.currentEvent, this.currentMenuItem.elements.childMenu.focusLastChild(), this.currentMenuItem.elements.childMenu.currentMenuItem.isSubmenuItem && this.currentMenuItem.elements.childMenu.currentMenuItem.elements.toggle.isOpen && (this.currentMenuItem.elements.childMenu.blurCurrentChild(), this.currentMenuItem.elements.childMenu.focusChildsLastNode());
      }
    }]);
  }(k);
  return {
    DisclosureMenu: $,
    Menubar: F,
    TopLinkDisclosureMenu: z,
    Treeview: H
  };
}();